//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";

import SearchFiltersGroup from "./SearchFiltersGroup";
export default {
	name: "SearchFilters",
	components: {
		SearchFiltersGroup,
	},
	data: function () {
		return {
			mobileOpen: false,
		};
	},
	computed: {
		...mapGetters(["settings", "results", "searchQuery"]),
		filters() {
			return this.results.filters.filter(g => {
				if (g.visible) return true;
				return g.filters.some(f => f.selected);
			});
		},
	},
	methods: {
		submitFilters() {
			this.$emit("submitfilters", this.getFilterQuerystring());
		},
		getFilterQuerystring() {
			const ids = [];
			this.searchQuery.filters.forEach((parent) => {
				const group = parent.filters
					.filter((c) => c.selected == true)
					.map((a) => a.id);

				if (group.length > 0) {
					ids.push(group);
				}
			});

			return ids.join(",");
		},
	},
};
